<script>
module.exports = {
  name: 'NoResultsSection',
  computed: {
    noResults() {
      return this.$store.state.noResults;
    },
    searchValue() {
      return this.$store.state.searchValue;
    },
  },
};
</script>

<template>
  <div v-if="noResults" class="no-results-container">
    <div class="no-results-text">
      <div>Sorry, there are no matching results for this search</div>
      <div v-show="searchValue">"{{ searchValue }}"</div>
      <div>Try a different search</div>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
